import { stringify as queryStringStringify } from 'query-string';

import { getCanonicalBrowsePathForPathname } from '@/utils/browsePath/browsePath';
import { getLegacyBrowseCanonicalRedirectPath } from '@/utils/browsePath/legacyQuadBrowseRedirect';
import { getPreservedRedirectParams } from '@/utils/queryParams';

type EarlyBrowseRedirectArgs = {
    browseParsed: unknown;
    pathname: string;
    queryParams: Record<string, any>;
};

export const getEarlyBrowseRedirectUrl = ({ browseParsed, pathname, queryParams }: EarlyBrowseRedirectArgs) => {
    if (!browseParsed || !queryParams.location) {
        return null;
    }

    const { location: _location, ...rest } = queryParams;
    const preserved = getPreservedRedirectParams(rest as Record<string, any>);
    const path = pathname.endsWith('/') ? pathname : `${pathname}/`;
    const qs = queryStringStringify(rest as Record<string, any>);
    return qs ? `${path}?${qs}` : `${path}${preserved}`;
};

type CanonicalBrowseRedirectArgs = {
    locationSearch: string;
    pathname: string;
};

export const getLegacyQuadBrowseRedirectUrl = ({ locationSearch, pathname }: CanonicalBrowseRedirectArgs) => {
    const trimmed = pathname.length > 1 && pathname.endsWith('/') ? pathname : `${pathname}/`;
    const legacyCanonical = getLegacyBrowseCanonicalRedirectPath(trimmed);
    if (!legacyCanonical) {
        return null;
    }
    const querySuffix = locationSearch && locationSearch !== '?' ? locationSearch : '';
    return `${legacyCanonical}${querySuffix}`;
};

export const getCanonicalBrowseRedirectUrl = ({ locationSearch, pathname }: CanonicalBrowseRedirectArgs) => {
    const canonicalBrowse = getCanonicalBrowsePathForPathname(pathname);
    if (!canonicalBrowse || canonicalBrowse === pathname) {
        return null;
    }

    const querySuffix = locationSearch && locationSearch !== '?' ? locationSearch : '';
    return `${canonicalBrowse}${querySuffix}`;
};
